The end date of the posting.
